import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  createContractualStatus,
  getContractualStatusList,
  getContractualStatusById,
  updateContractualStatusById,
  deleteContractualStatusById,
} from "./queries";

const ContractualStatusContext = createContext({});

export const useContractualStatusContext = () =>
  useContext(ContractualStatusContext);

export const ContractualStatusProvider = ({ ...props }) => {
  const [contractualStatusList, setContractualStatusList] = useState([]);
  const [contractualStatusById, setContractualStatusById] = useState({});

  const contractualStatusCreate = useCallback(async (data) => {
    try {
      await createContractualStatus(data);
      const updatedContractualStatusList = contractualStatusListGetter();
      setContractualStatusList(updatedContractualStatusList);
    } catch (e) {
      console.error("contractualStatusCreate", e);
      throw e;
    }
  }, []);

  const contractualStatusListGetter = useCallback(async () => {
    try {
      if (contractualStatusList.length === 0) {
        const result = await getContractualStatusList();
        setContractualStatusList(result);
      }
    } catch (e) {
      console.error("contractualStatusGetList", e);
    }
  }, [contractualStatusList]);

  const contractualStatusByIdGetter = useCallback(
    async (id) => {
      try {
        const result = await getContractualStatusById(id);
        setContractualStatusById(result);
      } catch (e) {
        console.error("contractualStatusByIdGetter", e);
        throw e;
      }
    },
    [setContractualStatusById]
  );

  const contractualStatusUpdateById = useCallback(async (id, data) => {
    try {
      const contractualStatusByIdUpdated = await updateContractualStatusById(
        id,
        data
      );
      const updatedContractualStatusList = contractualStatusListGetter();
      setContractualStatusById(contractualStatusByIdUpdated);
      setContractualStatusList(updatedContractualStatusList);
    } catch (e) {
      console.error("contractualStatusUpdateById", e);
      throw e;
    }
  }, []);

  const contractualStatusDeleteById = useCallback(
    async (id) => {
      try {
        await deleteContractualStatusById(id);
        const updatedContractualStatusList = contractualStatusListGetter();
        setContractualStatusList(updatedContractualStatusList);
      } catch (e) {
        console.error("contractualStatusDeleteById", e);
        throw e;
      }
    },
    [setContractualStatusList]
  );

  const values = useMemo(
    () => ({
      contractualStatusList,
      contractualStatusCreate,
      contractualStatusByIdGetter,
      contractualStatusUpdateById,
      contractualStatusListGetter,
      contractualStatusDeleteById,
      contractualStatusById,
      setContractualStatusById,
    }),
    [contractualStatusList, contractualStatusById]
  );
  return <ContractualStatusContext.Provider value={values} {...props} />;
};
